import React from 'react';
import PropTypes from 'prop-types';
import { computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import Skeleton from '@material-ui/lab/Skeleton';

import FormField from './FormField';
import Scenario from '../../api/Scenario';
import ScenarioOptionLabel from "../../views/scenarios/ScenarioOptionLabel";


@observer
class ScenarioFormField extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    filters: PropTypes.shape(),
    fullWidth: PropTypes.bool,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
  };
  static defaultProps = {
    filters: {},
    fullWidth: false,
    disabled: false,
    onChange: null,
  };

  @observable scenarios = null;

  async componentDidMount() {
    this.scenarios = await Scenario.getList(this.props.filters);
  }

  @computed get options() {
    const options = [];
    for (const scenario of this.scenarios) {
      options.push([scenario.id, <ScenarioOptionLabel scenarioId={scenario.id} />]);
    }
    return options;
  }

  render() {
    if (this.scenarios === null) {
      return <Skeleton variant="rect" height={55} />;
    }
    const { name, fullWidth, disabled, onChange } = this.props;
    return (
      <FormField
        name={name}
        options={this.options}
        variant="outlined"
        fullWidth={fullWidth}
        disabled={disabled}
        onChange={onChange}
      />
    );
  }
}


export default ScenarioFormField;
